export default "<div [chart]=\"battery\"></div>\n<button type=\"button\" (click)=\"refrash()\" class=\"btn btn-primary\">Refreash</button>"